/**
*
* ListMessages
*
*/

import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Alert, ListGroup } from 'react-bootstrap';
import DualInfiniteScroll from 'components/interaction/InfiniteScroll/DualInfiniteScroll.jsx';
import Spinner from 'components/Spinner/index.jsx';
import { idObject } from 'utils/arrays.js';
import messages from '../messages.js';
import TopicMessage from './TopicMessage.jsx';
import useTopicMessages from './useTopicMessages.js';
import useConversationsContext from '../useConversationsContext.js';

function ListMessages(props) {
  const { className, creating, ...rest } = props;
  const { topic } = useConversationsContext();
  const { hash } = useLocation();
  // eslint-disable-next-line no-unused-vars
  const topicMessages = useTopicMessages(topic);
  const { loading, totalCount, newCount } = topicMessages;
  // console.log('ListMessages', topicMessages);
  const participants = useMemo(() => idObject(topic.participants || [], 'uniqueId'), [topic.participants]);
  const [editing, setEditing] = useState(null);
  const anyEditing = creating || editing;

  useEffect(() => {
    if (hash && !loading) {
      window.setTimeout(() => {
        const elem = document.getElementById(hash.slice(1));
        if (elem) {
          elem.scrollIntoView();
        }
      }, 0);
    }
  }, [hash, loading]);

  if (!topic || !topic.messages) {
    return null;
  }
  if (loading && !totalCount) {
    return <Spinner />;
  }
  if (totalCount === 0) {
    return <Alert><FormattedMessage {...messages.empty} /></Alert>;
  }
  const showItem = (msg) => (
    <TopicMessage
      key={msg.id}
      message={msg}
      topic={topic}
      editing={anyEditing}
      setEditing={setEditing}
      participants={participants}
      {...rest}
    />
  );
  const separator = <div className="text-primary border-top border-primary text-center mx-4 py-3"><FormattedMessage {...messages.newMessages} values={{ count: newCount }} /></div>;
  return (
    <DualInfiniteScroll
      showItem={showItem}
      items={topicMessages}
      as={ListGroup}
      separator={separator}
      className={className}
      disableScroll={editing}
      bottomState={creating}
    >
    </DualInfiniteScroll>
  );
}

ListMessages.propTypes = {
  topic: PropTypes.object,
  bottomMargin: PropTypes.number,
  className: PropTypes.string,
  creating: PropTypes.bool,
};

export default ListMessages;
